import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, Injector, NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MultiPaymentTermsSelectorComponent } from './multi-payment-terms-selector.component';
import { SeFeFormFieldMultiselectModule } from 'se-fe-form-field-multiselect';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SeFeButtonModule } from 'se-fe-button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {HttpLoaderFactory, SharedModule} from '../app/shared.module';
import {SeFeFormFieldTextModule} from 'se-fe-form-field-text';
import { SeFeFormFieldModule } from 'se-fe-form-field';
import {SeFeFormFieldOptionsModule} from 'se-fe-form-field-options';
import {SeFeChipModule} from 'se-fe-chip';
import {SeFeAccordionModule} from 'se-fe-accordion';
import { SeFeHeaderModule } from 'se-fe-header';
import { seFeIconCalendarToday, seFeIconFlag, SeFeIconModule, seFeIconPlusCircle, seFeIconPlusCircleOutline, seFeIconRemove, seFeIconDollar } from 'se-fe-icon';
import {SeFeBlockModule} from 'se-fe-block';
import {SeFeDatepickerModule} from 'se-fe-datepicker';
import {SeFeMenuModule} from 'se-fe-menu';
import {SeFeToolbarModule} from 'se-fe-toolbar';

import { PaymentTermsPreviewComponent } from './payment-terms-preview/payment-terms-preview.component';
import { SeFeSpinnerModule } from 'se-fe-spinner';
import { SeFeEmptyStateModule } from 'se-fe-empty-state';
import { SeFeGridModule } from 'se-fe-grid';
import { SeFeModalModule } from 'se-fe-modal';
import { SeFePaginationModule } from 'se-fe-pagination';
import { SeFeServiceModule } from 'se-fe-service';
import { SeFeTableModule } from 'se-fe-table';
import { environment } from 'src/environments/environment';
import { SeFePopoverModule } from 'se-fe-popover';
import { SeFeAlertModule } from 'se-fe-alert';

@NgModule({
  declarations: [MultiPaymentTermsSelectorComponent, PaymentTermsPreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeFormFieldMultiselectModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeChipModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SeFeButtonModule,
    SeFeAccordionModule,
    SeFeHeaderModule,
    SeFeIconModule.include([
      seFeIconFlag,
      seFeIconPlusCircleOutline,
      seFeIconRemove,
      seFeIconPlusCircle,
      seFeIconCalendarToday,
      seFeIconDollar,
    ]),
    SeFeBlockModule,
    SeFeDatepickerModule,
    SharedModule,
    SeFeMenuModule,
    SeFeToolbarModule,
    SeFeSpinnerModule,
    SeFeButtonModule,
    SeFeEmptyStateModule,
    SeFeGridModule,
    SeFeModalModule,
    SeFePaginationModule,
    SeFeServiceModule.forRoot({ domainEnvironments: environment.domainEnvironments }),
    SeFeTableModule,
    SeFePopoverModule,
    SeFeAlertModule,
  ],
  providers: [CurrencyPipe, provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class MultiPaymentTermsSelectorModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(MultiPaymentTermsSelectorComponent, { injector: this.injector })
    if (!customElements.get('multi-payment-terms-selector-element')) {
      customElements.define('multi-payment-terms-selector-element', el)
    }
  }
}
